import { fromJson } from '@bufbuild/protobuf';
import type { ModeEvaluationEntity } from '@platform/timeline';
import {
  ModeEvaluationCompletedSchema,
  ModeEvaluationStartedSchema,
  ModeEvaluationUpdateSchema,
} from '../pb/proto/sem/middleware/mode_evaluation_pb';
import { registerSem } from '../registry';

registerSem('mode.evaluation.started', ({ ev, now, convId }) => {
  const pb = fromJson(ModeEvaluationStartedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'mode_evaluation',
      timestamp: now,
      props: {
        status: 'active',
        currentMode: pb.data?.currentMode ?? undefined,
        analysis: pb.data?.analysis ?? undefined,
        decision: pb.data?.decision ?? undefined,
        recommendedMode: pb.data?.recommendedMode ?? undefined,
      },
    } as ModeEvaluationEntity,
  };
});

registerSem('mode.evaluation.update', ({ ev, now, convId }) => {
  const pb = fromJson(ModeEvaluationUpdateSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'mode_evaluation',
      timestamp: now,
      props: {
        status: 'active',
        currentMode: pb.data?.currentMode ?? undefined,
        analysis: pb.data?.analysis ?? undefined,
        decision: pb.data?.decision ?? undefined,
        recommendedMode: pb.data?.recommendedMode ?? undefined,
      },
    } as ModeEvaluationEntity,
  };
});

registerSem('mode.evaluation.completed', ({ ev, now, convId }) => {
  const pb = fromJson(ModeEvaluationCompletedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'mode_evaluation',
      timestamp: now,
      props: {
        status: pb.success === false ? 'error' : 'completed',
        currentMode: pb.data?.currentMode ?? undefined,
        analysis: pb.data?.analysis ?? undefined,
        decision: pb.data?.decision ?? undefined,
        recommendedMode: pb.data?.recommendedMode ?? undefined,
        success: pb.success ?? undefined,
        error: pb.error ?? undefined,
      },
    } as ModeEvaluationEntity,
  };
});
